import React, { FC } from 'react'
import EditIsoContainer from 'containers/ISO/EditIso'

const EditIsoPage: FC = () => {
  return <EditIsoContainer />
}

export default EditIsoPage
